// location/openstreetmap
import toast from 'react-hot-toast';
import { showLog, showError } from 'src/utils/debug-log';

const getAddress = async (latlng) => {
  if(latlng){
    const [latitude, longitude] = latlng.split(',').map(Number);
    try {
      const url = `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`;
      showLog('Open url:', url);
      const response = await fetch(url);
      const data = await response.json();
      if(data){
        toast.custom(data.display_name, 6000);
        const address = data.address;
        if(address){
          return `${address.road || ''} ${address.quarter || ''}, ${address.suburb}, ${address.city}`;
        }
      }
    } catch (error) {
      showError(error);
    }
  }
  return null;
};

// const mockExtFunc = async (ext) => {
//   return new Promise((resolve) => setTimeout(() => resolve(`${ext}_processed`), 2000));
// };

export {
  getAddress,
} 
